import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, FlatList, Pressable, ScrollView, View } from "react-native";
import { ColorTokens, SizeTypeTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Space } from "../../space/Space";
import { isCloseToBottom, isMobile } from "../../stack/utils";
import { getScreenType, isFromAndroidWebview } from "../utils";
// import LottieView from "lottie-react-native";
const DemoVideos = ({ height, data, noOfColumns }) => {
    const isFromMobileView = isMobile(getScreenType());
    const [temporaryList, setTemporaryList] = useState([]);
    const [temporaryIndex, setTemporaryIndex] = useState(0);
    const [viewHeight, setHeight] = useState(Dimensions.get('window').height);
    const [isViewFromMobileView, setIsFromMobileView] = useState(false);
    useEffect(() => {
        if (Dimensions.get('window').height > 800) {
            setTemporaryList(prevData => [
                ...prevData,
                ...data.slice(temporaryIndex, temporaryIndex + 3)
            ]);
        }
        else {
            setTemporaryList(prevData => [
                ...prevData,
                ...data.slice(temporaryIndex, temporaryIndex + 2)
            ]);
        }
    }, [temporaryIndex, data]);
    const renderContent = ({ item }) => {
        return (React.createElement(Pressable, { style: {
                flexDirection: 'row',
                justifyContent: 'center',
                marginBottom: 36
            } },
            React.createElement(View, { style: { flexDirection: 'column', width: 304 } },
                !isFromMobileView &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: item['label'], typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Grey_Night, numberOfLines: 1 }),
                        React.createElement(Space, { size: SizeTypeTokens.MD })),
                React.createElement("iframe", { width: "304", height: "194", src: item["videoUrl"], style: {
                        borderRadius: 10,
                        borderColor: (isFromAndroidWebview() || isFromMobileView) ? 'black' : 'transparent',
                        borderBottom: (isFromAndroidWebview() || isFromMobileView) && '12px solid black',
                        borderTop: (isFromAndroidWebview() || isFromMobileView) && '12px solid black',
                        borderLeft: (isFromMobileView || isFromAndroidWebview()) && '0.5px solid grey',
                        borderRight: (isFromMobileView || isFromAndroidWebview()) && '0.5px solid grey',
                    }, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", allowFullScreen: true }),
                isFromMobileView && React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Typography, { label: item['label'], typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Grey_Night, numberOfLines: 1 })),
                React.createElement(View, { style: { marginRight: 24 } })),
            React.createElement(Space, { size: SizeTypeTokens.XXXL })));
    };
    useEffect(() => {
        const updateDimensions = () => {
            setHeight(Dimensions.get('window').height);
            setIsFromMobileView(Dimensions.get('window').height > 800);
        };
        Dimensions.addEventListener('change', updateDimensions);
        return () => {
            removeEventListener('change', updateDimensions);
        };
    }, []);
    const handleScroll = ({ nativeEvent }) => {
        if (isCloseToBottom(nativeEvent)) {
            if (temporaryIndex < data.length) {
                setTemporaryIndex(temporaryIndex + (isFromMobileView ? 3 : 2));
            }
        }
    };
    return (React.createElement(ScrollView, { onScroll: handleScroll, showsVerticalScrollIndicator: isFromMobileView, style: {
            height: isFromMobileView && height - 190,
            width: Dimensions.get('window').width > 1800 ? '90%' : '100%',
            marginBottom: 20
        }, nestedScrollEnabled: true, scrollEventThrottle: 16 },
        React.createElement(FlatList, { keyExtractor: (item) => item.row_id, contentContainerStyle: {
                alignSelf: 'flex-start',
            }, style: { marginTop: 24 }, data: isFromMobileView ? temporaryList : data, ItemSeparatorComponent: () => (React.createElement(Space, { size: SizeTypeTokens.LG })), numColumns: noOfColumns, renderItem: renderContent, showsVerticalScrollIndicator: isFromMobileView, nestedScrollEnabled: true, ListFooterComponent: () => (temporaryList.length !== 0 && isFromMobileView && temporaryIndex < data.length) &&
                React.createElement(ActivityIndicator, { color: '#1434CB', size: 22 }), maxToRenderPerBatch: 5, windowSize: 10 })));
};
// @ts-ignore
export default (DemoVideos);
